import styled from "styled-components";

export const MainDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const Title = styled.h1`
    font-size: 3.5rem;
    margin-bottom: 1rem;
    text-wrap: nowrap;
`

export const Location = styled.h3`
    font-size: 1.5rem;
    margin: 0;
`

export const Duration = styled.h3`
    font-size: 1.5rem;
    margin: 0;
`

export const Position = styled.h1`
    font-size: 1.5rem;
    margin-bottom: 1rem;
`